import React from "react";

import { Outlet } from "react-router-dom";

/**
 * Simple pass-through component that renders its children via Outlet
 */
const AppRoutes: React.FC = () => <Outlet />;

export default AppRoutes;
